<app-breadcrumb></app-breadcrumb>

<section class="mainContent">
  <div class="container">


    @if (favouritesService.favourites$ | async; as favourites) {
      <div class="row">
        <div class="col-12">
          @if (favourites.length > 0) {
            @for (thumbnail of favourites; track thumbnail; let i = $index) {
              <div class="col-lg-3 col-md-4">
                <app-thumbnail [thumbnail]="thumbnail" [index]="i"></app-thumbnail>
              </div>
            }
          } @else {
            <div class="col-12 not-found-message">
              <h2>No favourites added yet <i class="far fa-face-frown"></i></h2>
              <p>When you add some favourites, they will appear here!</p>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="row loading-message">
        <div style="width: 100%"><i class="fas fa-spinner fa-5x fa-spin"></i></div>
      </div>
    }
  </div>
</section>